<template>
    <b-table :data="files" @click="fileClicked" :detailed="showDetails" :loading="loading"  icon-pack="fas">
      <b-table-column v-slot:default="props" cellClass="is-clickable">
          <div class="icon is-large">
              <i class="fa-3x" :class="fileIcon(props.row)"></i>
          </div>
      </b-table-column>
      <b-table-column field="name" label="Name" v-slot:default="props" cellClass="is-clickable">
          {{ props.row.name }}
      </b-table-column>
      <b-table-column :visible="showDate" field="dateUploaded" label="Upload Date" v-slot="props" cellClass="is-clickable">
          {{ moment(props.row.dateUploaded).calendar() }}
      </b-table-column>
      <b-table-column field="humanSize" label="Size" v-slot:default="props" cellClass="is-clickable">
          {{ props.row.humanSize }}
      </b-table-column>
      <b-table-column :visible="showType" field="type" label="Type" v-slot:default="props" cellClass="is-clickable">
          {{ props.row.type.substring(props.row.type.indexOf('/')+1) }}
      </b-table-column>
      <b-table-column :visible="!autoPreview" v-slot:default="props" label="">
        <template  v-if="props.row.type === 'text/csv' && !autoPreview">
          <router-link :to="{name: 'csv-viewer', params: {fileId: props.row.id}}" class="button" @click.stop="">Preview</router-link>
        </template>
      </b-table-column>

        <template v-slot:detail="props">
            <article class="media">
                <div class="media-left" style="width: 11%;">
                </div>
                <div class="media-content">
                    <div class="content">
                        <div>
                            <strong>{{ props.row.realFileName }}</strong>
                            <br>

                            <div class="tags">
                                <span v-if="props.row.created_by" class="tag has-background-grey-light">{{ props.row.created_by }}</span>
                                <span class="tag has-background-grey-light">{{ moment(props.row.dateUploaded).format('MMM D, YYYY') }}</span>
                            </div>
                            <div class="content">
<!--                                IMPORTANT:  HTML Escaping happens here.  The database may contain malicious code, but we don't care because this escapes it.-->
                                {{ props.row.description }}
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </template>
    </b-table>
</template>

<script>
    import moment from "moment";
    import BButton from "buefy/src/components/button/Button"
    import BTable from "buefy/src/components/table/Table";
    import BTableColumn from "buefy/src/components/table/TableColumn";

    export default {
        name: "FileList",
        components: {BTableColumn, BTable, BButton},
        props: {
            files: {
                type: Array,
                default: [],
            },
            showType: {
                type: Boolean,
                default: true,
            },
            showDate: {
                type: Boolean,
                default: true,
            },
            showDetails: {
                type: Boolean,
                default: true,
            },
            autoPreview: {
                type: Boolean,
                default: false,
            },
            loading: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            fileClicked(file) {
                if(file.type === 'text/csv' && this.autoPreview) {
                    this.$gtag.event('view', {event_category: 'File', event_label: file.name});
                    this.$router.push({name: 'csv-viewer', params: {fileId: file.id}});
                    return;
                }
                this.$gtag.event('download', {event_category: 'File', event_label: file.name});
                window.open(file.file);
            },
            //The icon to display for each file
            fileIcon(file) {
                if (!this.showType) {
                    return ["far", "fa-file"];
                }
                switch (file.type) {
                    case "text/csv":
                        return ["fas", "fa-file-csv"];
                    case "application/pdf":
                        return ["far", "fa-file-pdf"];
                }
                return ["far", "fa-file"];
            },
            moment,
        },
    }
</script>

<style scoped>

</style>